import { AutoFactory, DataFieldsApi, PropertyOptionsApi } from '@sageworks/jpi';
import { TemplateDataField } from '../../../enums';

export const getCollateralTypeOptions = async function() {
	const dataFieldService: DataFieldsApi = AutoFactory.get(DataFieldsApi);
	const propertyOptionsService: PropertyOptionsApi = AutoFactory.get(PropertyOptionsApi);
	const collectionResponse = await dataFieldService.getPaged(1, 1, undefined, undefined, undefined, [TemplateDataField.CollateralType]);
	const dataField = collectionResponse?.items?.pop();
	return await propertyOptionsService.getSingle(dataField?.id ?? 0);
};
